import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {PeriodResult, PeriodResultSearchParams} from '@accounting/_common/models/period-result.models';

export const CheckState = createAction(
    '[PeriodResults] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: PeriodResult[] } }>()
);

export const CheckStateSuccess = createAction(
    '[PeriodResults] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: PeriodResult[] } }>()
);

export const LoadList = createAction(
    '[PeriodResults] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[PeriodResults] Load List Success',
    props<{ payload: { items: PeriodResult[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[PeriodResults] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[PeriodResults] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[PeriodResults] Set Filter',
    props<{ payload: PeriodResultSearchParams }>()
);

export const SetLoading = createAction(
    '[PeriodResults] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[PeriodResults] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[PeriodResults] Update Item Success',
    props<{ payload: PeriodResult }>()
);

export const DeleteItem = createAction(
    '[PeriodResults] Delete Item',
    props<{ payload: PeriodResult }>()
);

export const DeleteItemSuccess = createAction(
    '[PeriodResults] Delete Item Success',
    props<{ payload: PeriodResult }>()
);

export const DeleteItemFailure = createAction(
    '[PeriodResults] Delete Item Failure',
    props<{ payload: PeriodResult }>()
);

export const SetInitialState = createAction(
    '[PeriodResults] Set Initial State'
);
